module.exports = __webpack_public_path__ + "img/product-tutorial-2-flower-face.c6344b0a.svg";